module.exports = __webpack_public_path__ + "static/media/airtable.5e9bf2f5.svg";